import { useEffect, useState } from "react";
import {
  FaComments,
  FaPeopleGroup,
  FaScaleBalanced,
  FaNetworkWired,
} from "react-icons/fa6";
import UserInfo from "../components/UserInfo";

import { MdOutlineSupervisorAccount } from "react-icons/md";

const principios = [
  { texto: "Respeto a la diversidad humana", icono: FaPeopleGroup },
  { texto: "Enfoque de derechos", icono: FaScaleBalanced },
  { texto: "Acompañamiento integral", icono: MdOutlineSupervisorAccount },
  { texto: "Horizontalidad y escucha activa", icono: FaComments },
  { texto: "Trabajo interdisciplinario", icono: FaNetworkWired },
];

const equipo = [
  {
    nombre: "José Perich",
    rol: "Co fundador",
    foto: "/img/jose.jpg",
    bio: "Licenciado en educación diferencial y activista por los derechos de las personas autistas. Fundador del Colectivo Autismo Chile y cofundador de Centro Divergente.",
  },
  {
    nombre: "Marjorie Barrera",
    rol: "Co fundadora",
    foto: "/img/marjorie.jpg",
    bio: "Educadora diferencial, diplomada en inclusión educativa y cofundadora de Centro Divergente.",
  },
];

export default function Landing() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    async function fetchUser() {
      try {
        const response = await fetch("/api/user-info", {
          credentials: "include",
        });
        setUser(response.ok ? await response.json() : null);
      } catch (error) {
        console.error("Error al obtener el usuario:", error);
        setUser(null);
      }
    }
    fetchUser();
  }, []);

  return (
    <main className="divergente-home">
      {user && <UserInfo user={user} />}

      <section className="home-hero" id="inicio">
        <div className="hero-copy">
          <p className="home-kicker">
            Centro de diagnóstico y apoyo al neurodesarrollo
          </p>
          <h1>
            Más allá del diagnóstico, <span>las personas.</span>
          </h1>
          <p className="hero-description">
            Evaluación y acompañamiento desde una perspectiva
            interdisciplinaria, social y de derechos.
          </p>
          <div className="hero-actions">
            <a className="home-button home-button-primary" href="#contacto">
              Conversemos
            </a>
          </div>
        </div>
        <div
          className="hero-visual"
          aria-label="Nuestro espacio en Providencia"
        >
          <div className="hero-visual-shape" />
          <img
            src="/img/centro1.jpg"
            alt="Fachada del entorno de Centro Divergente"
          />
          <div className="hero-stamp">
            <span>Personas</span>
            <strong>al centro</strong>
          </div>
          <span className="hero-orbit hero-orbit-one" />
          <span className="hero-orbit hero-orbit-two" />
        </div>
      </section>

      <section className="home-section home-about" id="nosotros">
        <div className="section-heading">
          <p className="home-kicker">Quiénes somos</p>
          <h2>Un espacio para comprender, orientar y acompañar.</h2>
        </div>
        <div className="about-copy">
          <p>
            Somos un centro especializado en evaluación diagnóstica y
            acompañamiento de personas autistas. Nuestro equipo reúne distintas
            disciplinas para comprender a cada persona en su singularidad, junto
            a su historia, entorno y necesidades de apoyo.
          </p>
          <p>
            Divergente nació de una necesidad concreta: ofrecer orientación y
            evaluaciones especializadas a personas y familias. Nos mueve la
            convicción de que todas las personas merecen ser comprendidas,
            respetadas y acompañadas en sus proyectos de vida.
          </p>
        </div>
        <div className="about-photo-row">
          <img
            src="/img/centro2.jpg"
            alt="Espacio de atención de Centro Divergente"
          />
          <div>
            <span className="about-red-line" />
            <p>
              Una mirada que va más allá de un diagnóstico: reconoce a la
              persona y sus proyectos de vida.
            </p>
          </div>
        </div>
      </section>

      <section className="home-approach" id="enfoque">
        <div className="approach-content">
          <p className="home-kicker">
            Nuestra forma de comprender la evaluación
          </p>
          <h2>Conocer a la persona es el comienzo.</h2>
          <p>
            La evaluación es un proceso de conocimiento y comprensión de cada
            persona, su historia, sus características y sus necesidades de
            apoyo. Buscamos aportar información significativa que oriente
            decisiones, facilite apoyos y contribuya a mejorar su calidad de
            vida.
          </p>
        </div>
        <div className="approach-quote">
          <span>“</span>
          <p>
            Comprender a una persona implica mucho más que identificar un
            diagnóstico.
          </p>
        </div>
      </section>

      <section className="home-section home-principles" id="principios">
        <div className="section-heading centered-heading">
          <p className="home-kicker">La base de cada encuentro</p>
          <h2>Nuestros principios</h2>
          <p className="principles-intro">
            Ideas que orientan cómo evaluamos, acompañamos y trabajamos junto a
            cada persona y su familia.
          </p>
        </div>
        <div className="principle-grid">
          {principios.map(({ texto, icono: Icono }, index) => (
            <article className="principle-card" key={texto}>
              <span className="principle-number">0{index + 1}</span>
              <span className="principle-icon" aria-hidden="true">
                <Icono />
              </span>
              <h3>{texto}</h3>
            </article>
          ))}
        </div>
      </section>

      {/*Equipo de trabajo

      <section className="home-team" id="equipo">
        <div className="team-heading">
          <div>
            <p className="home-kicker">Las personas detrás de Divergente</p>
            <h2>Equipo de Trabajo</h2>
          </div>
        </div>
        <div className="home-team-grid">
          {equipo.map((profesional) => (
            <article className="home-team-card" key={profesional.nombre}>
              <div className="team-photo">
                <img
                  src={profesional.foto}
                  alt={`Retrato de ${profesional.nombre}`}
                />
                <span>{profesional.rol}</span>
              </div>
              <div className="team-card-copy">
                <h3>{profesional.nombre}</h3>
                <p>{profesional.bio}</p>
              </div>
            </article>
          ))}
        </div>
      </section>
*/}

      {/*
      <section className="home-course" id="cursos">
        <div className="course-image">
          <img
            src="/img/corregulacion.jpg"
            alt="Curso de corregulación y educación emocional"
          />
        </div>
        <div className="course-copy">
          <p className="home-kicker">Aprender para acompañar</p>
          <h2>Herramientas para una educación emocional respetuosa.</h2>
          <p>
            Conoce nuestros cursos online y recursos para familias, comunidades
            educativas y profesionales.
          </p>
          <a
            className="home-button home-button-dark"
            href="/curso-online/coregulacion-y-educacion-emocional"
          >
            Explorar cursos <span aria-hidden="true">↗</span>
          </a>
        </div>
      </section>
*/}
      <section className="home-contact" id="contacto">
        <div className="contact-copy">
          <p className="home-kicker">Conversemos</p>
          <h2>Estamos aquí para acompañarte.</h2>
          <p>
            Evaluación y acompañamiento especializado en autismo y otras
            condiciones del neurodesarrollo.
          </p>
          <a
            className="contact-whatsapp"
            href="https://wa.me/56959282351"
            target="_blank"
            rel="noreferrer"
          >
            +56 9 5928 2351 <span aria-hidden="true">↗</span>
          </a>
          <p className="contact-address">
            Av. Providencia 2315, Providencia, Santiago
            <br />
            Cerca del Metro Los Leones
          </p>
          <a
            className="contact-instagram"
            href="https://www.instagram.com/centro_divergente/"
            target="_blank"
            rel="noreferrer"
          >
            Instagram · @centro_divergente
          </a>
        </div>
        <div className="contact-map">
          <iframe
            title="Ubicación de Centro Divergente en Providencia"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3330.0934393419834!2d-70.6125592074313!3d-33.42080820481867!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662cf68f0f9bacb%3A0xd0ad951d78a81a84!2sAv.%20Providencia%202315%2C%20Providencia%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1ses-419!2scl!4v1737147383769!5m2!1ses-419!2scl"
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </section>

      <footer className="home-footer">
        <a href="#inicio">
          Centro Divergente <span>↑</span>
        </a>
        <p>Más allá del diagnóstico, las personas.</p>
      </footer>
    </main>
  );
}
